export const ONBOARDING_TEAM_LOCAL_STORAGE_KEY = 'ONBOARDING_CREATED_TEAM_ID'
export const FIREBASE_EMAIL_LOCAL_STORAGE_KEY = 'emailForSignIn'
